import { exclusiveStories } from "@/mocks/baoliao";

const badge: Record<string, string> = {
  debut: "bg-accent-500 text-foreground-950",
  leak: "bg-primary-500 text-background-50",
  secret: "bg-secondary-200 text-foreground-900",
  rumor: "bg-background-50 text-foreground-950",
};

export default function Exclusive() {
  const lead = exclusiveStories[0];
  const rest = exclusiveStories.slice(1);
  return (
    <section id="exclusive" className="scroll-mt-20 bg-foreground-950 text-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12 md:py-16">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3 mb-8">
          <div>
            <p className="text-xs text-accent-400 font-medium tracking-widest uppercase">EXCLUSIVE</p>
            <h2 className="mt-1 text-2xl md:text-3xl text-background-50">独家 · 首发 · 深挖</h2>
          </div>
          <p className="text-sm text-background-100/70 max-w-md">
            由呱呱爆料编辑部原创跟进，全网最先发布的深度吃瓜内容。
          </p>
        </div>

        {/* 头条独家大图 */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5 mb-5">
          <a
            href="#feed"
            className="group lg:col-span-7 relative overflow-hidden rounded-xl block h-[300px] md:h-[400px]"
          >
            <img
              src={lead.img}
              alt={lead.title}
              className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/95 via-foreground-950/30 to-transparent" />
            <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
              <span
                className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-medium ${badge[lead.tagType]}`}
              >
                <i className="ri-fire-fill" />
                {lead.tag}
              </span>
              <h3 className="mt-3 text-lg md:text-2xl text-background-50 leading-snug font-bold">
                {lead.title}
              </h3>
              <p className="mt-2 hidden sm:block text-sm text-background-100/80 line-clamp-2 max-w-2xl">{lead.desc}</p>
            </div>
          </a>

          {/* 三小图并列 */}
          <div className="lg:col-span-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-4">
            {rest.map((s) => (
              <a
                key={s.id}
                href="#feed"
                className="group flex items-center gap-4 rounded-xl overflow-hidden bg-foreground-900 hover:bg-foreground-800 transition-colors p-3"
              >
                <div className="relative w-24 h-20 rounded-lg overflow-hidden shrink-0">
                  <img
                    src={s.img}
                    alt={s.title}
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <span
                    className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] ${badge[s.tagType]}`}
                  >
                    {s.tag}
                  </span>
                  <p className="mt-1.5 text-sm text-background-100 leading-snug group-hover:text-background-50 transition-colors line-clamp-2">
                    {s.title}
                  </p>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}